import * as React from 'react';

import { BULLETS, ICONS, ListContext, NUMBERS } from './List';
import {
  ListItemBulletIcon,
  ListItemNumber,
  ListItemTextWrapper,
  ListItemWithIcon,
  StyledListItem
} from './ListStyles';

export interface IListItemProps {
  children: React.ReactNode;
}

export const useListContext = () => React.useContext(ListContext);

const ListItem: React.FC<IListItemProps> = ({ children }) => {
  const { iconProps, listStyleProps } = useListContext();

  switch (listStyleProps.type) {
    case BULLETS:
      return (
        <StyledListItem>
          <ListItemBulletIcon colorProp={listStyleProps.color} />
          <ListItemTextWrapper>{children}</ListItemTextWrapper>
        </StyledListItem>
      );
    case ICONS:
      return (
        <StyledListItem>
          <ListItemWithIcon
            colorProp={listStyleProps.color}
            icon={iconProps && iconProps.type}
            size={iconProps && iconProps.size}
          />
          <ListItemTextWrapper>{children}</ListItemTextWrapper>
        </StyledListItem>
      );
    case NUMBERS:
      return (
        <>
          <ListItemNumber colorProp={listStyleProps.color}>
            {children}
          </ListItemNumber>
        </>
      );
    default:
      return (
        <StyledListItem>
          <ListItemBulletIcon colorProp={listStyleProps.color} />
          <ListItemTextWrapper>{children}</ListItemTextWrapper>
        </StyledListItem>
      );
  }
};

export default ListItem;
